export default __webpack_public_path__ + "static/media/wow.7dd8cde8.gif";